import { API_URI } from "../../constants/env";

const WooCommerceRestApi = require("@woocommerce/woocommerce-rest-api").default;

export const wooCommerceApi = new WooCommerceRestApi({
  url: API_URI,
  consumerKey: "ck_17b7fc5c9488cee4cf85bfec23908b86fdd358ff",
  consumerSecret: "cs_474fb041d51371849d37eddb9cd19117f001cc12",
  version: "wc/v3"
});